import { useEffect, useState } from 'react'

const FIELD_STATES = {
  ERROR: 'error',
  SUCCESS: 'success',
  DEFAULT: 'default',
}

export const useFieldState = ({
  required = false,
  validatorFunction,
  defaultErrorState,
  forceError,
  onBlurEvent,
}) => {
  const [fieldState, setFieldState] = useState(
    defaultErrorState ? FIELD_STATES.ERROR : FIELD_STATES.DEFAULT
  )

  useEffect(() => {
    if (forceError === true) {
      setFieldState(FIELD_STATES.ERROR)
    } else if (forceError === false && fieldState === FIELD_STATES.ERROR) {
      setFieldState(FIELD_STATES.DEFAULT)
    }
  }, [forceError])

  const validate = (value) => {
    if (validatorFunction && !validatorFunction(value)) {
      return FIELD_STATES.ERROR
    } else if (required && !value) {
      return FIELD_STATES.ERROR
    } else if (value) {
      return FIELD_STATES.SUCCESS
    }
  }

  const handleOnblur = (e) => {
    setFieldState(validate(e))
  }

  return {
    handleOnblur,
    validate,
    fieldState,
    isError: fieldState === FIELD_STATES.ERROR,
    isSuccess: fieldState === FIELD_STATES.SUCCESS,
  }
}
